import { render } from "./NextPageLink.vue?vue&type=template&id=4b919881"
import script from "./NextPageLink.vue?vue&type=script&lang=js"
export * from "./NextPageLink.vue?vue&type=script&lang=js"
script.render = render

export default script